import React from 'react';
import { Box, BoxProps } from '../../wag-react/next-components/box';
type Props = BoxProps & Required<Pick<BoxProps, 'children'>>;
export const ArticleSectionContent = (props: Props) => <Box {...props} data-sentry-element="Box" data-sentry-component="ArticleSectionContent" data-sentry-source-file="ArticleSectionContent.tsx" />;
export type ArticleSectionContent = Props;